import {
  Link,
  useParams,
  NavLink
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/antmedicos";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllAntmedicosByTax(params.tratamientoId);
}

export function AntmedicosList(props) {
  const [antmedicosList, setAntmedicos] = useState([]);
  let { tratamientoId } = useParams();
  let lastItem;

  useEffect(() => {
    API.getAllAntmedicosByTax(props.id).then(setAntmedicos).catch(console.log);
  }, [props.id]);

  return (
    <>
      {antmedicosList?.length ? (
        <ul className="entrenamiento cpt-list">
            {antmedicosList
              .sort((a, b) => {
                // Convertir las fechas a objetos de fecha para comparar
                const dateA = new Date(a.meta.metaFecha);
                const dateB = new Date(b.meta.metaFecha);
                // Ordenar de manera descendente (más reciente primero)
                return dateB - dateA;
              })
              .map((antmedicos) => (
                <li key={antmedicos.id}>
                <NavLink className="capitalize" to={`${props.id}/antecedentes/medicos/${antmedicos.id}`}>
                  {`${FormatDate(antmedicos.meta.metaFecha)} - ${antmedicos.meta?.antmedTipo !== 'Valoración' ? 'Ingreso' : 'Valoración'}`}
                </NavLink>
                </li>
              ))}
          </ul>
          ) : (
            <></>
          )}
    </>
  );
}



export function AntmedicosListContent(props) {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id="content">
        <h1>Antecedentes Médicos</h1>
      </div>
      <div id="actions">
      {(props.userRole.includes('administrador') || props.userRole.includes('medicina')) && (
        <Link className="button is-link" to={`new`}>Nuevo</Link>
      )}
      </div>
    </>
  );
}